import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import ConfigPage from './pages/ConfigPage';
import TrackingPage from './pages/TrackingPage';
import ProgressPage from './pages/ProgressPage';
import SignInPage from './pages/SignInPage';
import { AuthProvider, useAuth } from './context/AuthContext';
import { DataProvider } from './context/DataContext';

function AuthenticatedApp() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="card">
        <div className="empty-state">
          <h3>Loading...</h3>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <SignInPage />;
  }

  return (
    <DataProvider>
      <Navigation />
      <main className="main-content">
        <div className="container">
          <Routes>
            <Route path="/" element={<Navigate to="/config" replace />} />
            <Route path="/config" element={<ConfigPage />} />
            <Route path="/tracking" element={<TrackingPage />} />
            <Route path="/progress" element={<ProgressPage />} />
            <Route path="*" element={<Navigate to="/config" replace />} />
          </Routes>
        </div>
      </main>
    </DataProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <AuthenticatedApp />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
